import {Component, Inject, LOCALE_ID} from '@angular/core';
import {FilterFieldCustomEnabled} from '../../../../../common/services/responses/filter-field-custom-enabled.model';
import {DatePipe} from '@angular/common';
import {FieldType} from '../../../../../common/components/form/models';
import {FilterEnableComponent} from '../../common/filter-enable.component';
import {Entite} from '@Services/entite/entite.model';

@Component({
  selector: 'app-filter-custom-enabled',
  templateUrl: '../../common/filter-enable.component.html',
  styleUrls: ['../../common/filter-enable.component.scss']
})
export class FilterCustomEnabledComponent extends FilterEnableComponent {
  constructor(@Inject(LOCALE_ID) public locale: string) {
    super();
  }
  getValue(filter: FilterFieldCustomEnabled) {
    if (filter.type === FieldType.TypeDate) {
      const dp: DatePipe = new DatePipe(this.locale);
      return dp.transform(`${filter.value}`, 'dd/MM/yyyy');
    }
    if (filter.type === FieldType.TypeSvcCmp) {
      const value = filter.value as Entite;
      return value.entite_obj['name'];
    }
    return filter.value;
  }
}
